import React, { useEffect, useState } from "react";
import "../styles/marketing-dashboard.css";

const TestEmailInput = ({ setTestEmail, handleSubmit }) => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);

  const timer = setTimeout(() => {
    setSuccess(null);
    setError(null);
  }, 3500);
  const handleTestEmail = (e) => {
    e.preventDefault();
    setTestEmail(e.target.value);
  };
  const handleTestPush = async () => {
    setLoading(true);
    try {
      await handleSubmit();
      setSuccess(true);
      setLoading(false);
    } catch (err) {
      setError(true);
      console.log("ERROR: sending test notification", err);
      setLoading(false);
    }
    return () => clearTimeout(timer);
  };
  useEffect(() => {
    return () => {
      setSuccess(null);
      setError(null);
      setLoading(false);
      clearTimeout(timer);
    };
  }, []);
  return (
    <div className="flex-col mx-auto text-black justify-center text-center">
      <input
        type="email"
        onChange={(e) => handleTestEmail(e)}
        pattern=".+@globex\.com"
        size="30"
        required
        placeholder="example@email.com"
        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring"
      />
      {success ? (
        <button type="button" className=" bg-green-500 my-3 py-1 px-3 mx-auto">
          <i className="fas fa-check-circle " />
        </button>
      ) : (
        <>
          {error ? (
            <button
              type="button"
              className=" bg-red-500 my-3 py-1 px-3 mx-auto"
            >
              <small>
                Error
                <i className="mx-1 fas fa-exclamation-circle" />
              </small>
            </button>
          ) : (
            <button
              aria-label="send test push notification"
              type="button"
              className=" bg-yellow-600 my-3 py-1 px-3 mx-auto animate__animated animate__bounce"
              onClick={() => handleTestPush()}
            >
              {loading ? (
                <i className="fas fa-spinner text-white fa-spin p-1" />
              ) : (
                <small className="text-white">
                  Send
                  <i className="fas fa-paper-plane text-white p-1" />
                </small>
              )}
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default TestEmailInput;
